
import 'react-circular-progressbar/dist/styles.css';
import { useAppContext,UserAvatarProps } from '../../AppContext';





function UserAvatar(props: UserAvatarProps) {
    return <img
        src={props.user.avatar || 'static/img/no-profile-picture.jpeg'} alt="Active Directory Photo"

    ></img>;
}
function UserInfoComponent({...props }) {
    const app = useAppContext();
  const user = app.user || { displayName: '', email: '' };

    
  return (
  

   <div className="item-col-lg-25 d-lg-block d-none">

   <div className="user">

      
       <UserAvatar user={user} />
       <div className="bar-box bar-box1">
           <h4>{props.userData['displayName']}</h4>
       </div>
       <div className="bar-box bar-box2">
           <h6 className="mb-0">{props.userData['jobTitle']}</h6>
       </div>

       <div className="bar-link">
                    <a href="/Calendar" >تقويم الاسبوع</a>
     </div>
<br/>

       <div className="bar-link">
           <a href="#" onClick={app.signOut!}>خروج</a>
       </div>
   </div>
   <div className="bar-progres-rounded text-center">
{/*    <SiderParProgressbarComponent/>
   <SiderParProgressbarComponent/> */}


   </div>
</div>

  );
}

export default UserInfoComponent;


